import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { Card } from '../common/Card/Card';
import * as S from './ChatInboxLayout.styles';
import ChatInboxList from './ChatInboxList/ChatInboxList';
import { PageTitle } from '../common/PageTitle/PageTitle';

const ChatInboxLayout: React.FC = () => {
  const { t } = useTranslation();

  return (
    <S.ChatWrapper>
      <PageTitle>{t('chats.pageTitle')}</PageTitle>
      <Card title={t('chats.title')} padding="1.25rem">
        <Row gutter={[30, 0]} style={{ height: '100%' }}>
          <Col xs={24} md={24} xl={10} style={{ height: '100%', overflow: 'hidden' }}>
            <ChatInboxList />
          </Col>
          <Col xs={24} md={24} xl={14} style={{ height: '100%', overflow: 'hidden' }}>
            <Outlet />
          </Col>
        </Row>
      </Card>
    </S.ChatWrapper>
  );
};

export default ChatInboxLayout;
